// ---------------------------------------------------------------------------
// Knowing a long-lived SSE stream is still alive.
//
// The support stream's heartbeat is an SSE *comment* (`: keepalive`). `fetchEventSource` parses
// it and throws it away, so no `onmessage` ever fires for it, and a socket that a NAT or a
// sleeping radio dropped silently looks exactly like a quiet one. The only honest signal is the
// raw bytes arriving, so this wraps the response and reports every chunk read from its body.
// ---------------------------------------------------------------------------
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * A Proxy over `target` that answers the named properties from `overrides` and everything else
 * from the real object, with methods bound to it (Response/ReadableStream methods and getters
 * throw "Illegal invocation" when called on the proxy itself).
 */
function withOverrides(target, overrides) {
    return new Proxy(target, {
        get(real, prop) {
            if (typeof prop === 'string' && Object.prototype.hasOwnProperty.call(overrides, prop))
                return overrides[prop];
            const value = Reflect.get(real, prop, real);
            return typeof value === 'function' ? value.bind(real) : value;
        }
    });
}
/**
 * `response`, unchanged in every way except that `onBytes` runs each time a chunk (data OR a
 * comment line) is read from its body. A response with no body is returned as is.
 */
export function trackStreamActivity(response, onBytes) {
    const { body } = response;
    if (!body)
        return response;
    const trackedBody = withOverrides(body, {
        getReader: () => {
            const reader = body.getReader();
            return withOverrides(reader, {
                read: () => __awaiter(this, void 0, void 0, function* () {
                    const result = yield reader.read();
                    if (!result.done)
                        onBytes();
                    return result;
                })
            });
        }
    });
    return withOverrides(response, { body: trackedBody });
}
